import React from 'react';
import AgencyTemplate from '../components/AgencyTemplate';

const LanzhouLSPE = () => {
	const agencyData = {
		title: "Lanzhou LS Petroleum Equipment Engineering Co",
		subtitle: "Petrochoice Agencies",
		description: "Lanzhou LS Petroleum Equipment Engineering Co., ltd (short for LSPE) was built in 1953, it is the pioneer in China's oil drilling and production equipment manufacturing industry. Partnering with US-based National Oilwell Varco (NOV), Lanzhou LS offers highly reliable products across China, Asia, Europe, and Africa. Their solutions are well-regarded in the Egyptian market, in collaboration with EDC and ADES. They provide Land Rig solutions, Offshore Rig and necessary equipment, Oil extraction equipment and fracturing equipment.",
		image: "/assets/lanzhou-logo.jpg",
		imageAlt: "Lanzhou LS Petroleum Equipment Engineering logo",
		features: [
			{
				title: "Pioneer in Equipment Manufacturing",
				description: "Founded in 1953, LSPE is the pioneer in China's oil drilling and production equipment manufacturing industry with decades of experience and expertise.",
				icon: "bi bi-award",
				iconColor: "#0c61c0"
			},
			{
				title: "Global Partnership",
				description: "Partnering with US-based National Oilwell Varco (NOV), Lanzhou LS offers highly reliable products across China, Asia, Europe, and Africa with solutions well-regarded in the Egyptian market.",
				icon: "bi bi-globe",
				iconColor: "#28a745"
			}
		],
		additionalSections: [
			{
				title: "Equipment Solutions",
				items: [
					[
					{ icon: "bi bi-gear", iconColor: "#007bff", title: "Land Rig Solutions", description: "Complete land drilling rig services and equipment" },
					{ icon: "bi bi-water", iconColor: "#17a2b8", title: "Offshore Rig Equipment", description: "Marine drilling equipment and necessary offshore services" }
					],
					[
						{ icon: "bi bi-droplet", iconColor: "#28a745", title: "Oil Extraction Equipment", description: "Advanced oil extraction and production equipment" },
						{ icon: "bi bi-lightning", iconColor: "#ffc107", title: "Fracturing Equipment", description: "Hydraulic fracturing services and related equipment" }
					]
				]
			}
		]
	};

	return <AgencyTemplate {...agencyData} />;
};

export default LanzhouLSPE;



